import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { IconAvatar } from './IconAvatar';
import { SharingListItem } from './SharingListItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const GroupListItem = ({
  avatarInitial,
  name,
  subtitle
}) => {
  return /*#__PURE__*/_jsx(SharingListItem, {
    testId: "group-list-item",
    avatar: /*#__PURE__*/_jsx(IconAvatar, {
      children: avatarInitial
    }),
    primaryText: name,
    secondaryText: subtitle,
    badge: /*#__PURE__*/_jsx(Badge, {
      use: "koala",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.sharingPanel.visitorsBadge"
      })
    })
  });
};